import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../assets/leadSourceCreate.module.css';

const LeadSourceCreate = () => {
  const [formData, setFormData] = useState({
    name: ''
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    } else if (formData.name.length > 255) {
      newErrors.name = 'Name cannot exceed 255 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    try {
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const response = await fetch(`${baseUrl}/api/leadsources`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(formData)
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success(data.message || 'Lead source created successfully!');
        navigate('/lead-sources');
      } else {
        toast.error(data.message || 'Failed to create lead source');
      }
    } catch (error) {
      console.error('Error creating lead source:', error);
      toast.error('Failed to create lead source');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/lead-sources');
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumbs */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/dashboard">Dashboard</a>
          </li>
          <li className="breadcrumb-item">
            <a href="/clients">Clients</a>
          </li>
          <li className="breadcrumb-item">
            <a href="/lead-sources">Lead Sources</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Create Lead Source
          </li>
        </ol>
      </nav>

      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default panel-standard">
            <div className="panel-heading panel-title">
              <h3 className="mr-auto">Create Lead Source</h3>
            </div>
            <div className="panel-body">
              <form onSubmit={handleSubmit} className="form-horizontal">
                <div className="form-group">
                  <label htmlFor="name" className="control-label col-sm-3">
                    Name <span className="text-danger">*</span>
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                      placeholder="Enter lead source name"
                      maxLength={255}
                    />
                    {errors.name && (
                      <div className="invalid-feedback">
                        {errors.name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <div className="col-sm-offset-3 col-sm-9">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? 'Creating...' : 'Create Lead Source'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-default ml-2"
                      onClick={handleCancel}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadSourceCreate; 